/* eslint-disable react/prop-types */
import React, { useMemo, useState } from "react";
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import { ThemeProvider } from "@mui/material/styles";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import HistoryEduOutlinedIcon from "@mui/icons-material/HistoryEduOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import ComputerOutlinedIcon from "@mui/icons-material/ComputerOutlined";
import TranslateOutlinedIcon from "@mui/icons-material/TranslateOutlined";
import en from "../../nls/en.json";
import { theme, OptionsWrapper } from "../Styles/AcademicSubjectsStyle";
import { isEmpty } from "../../utils/constants";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const iconMap = {
  "Science": <ScienceOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
  "Math": <CalculateOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
  "Art": <BrushOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
  "History": <HistoryEduOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
  "English": <MenuBookOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
  "Computer Science": <ComputerOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
  "Language Learning": <TranslateOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
  "Other": <MenuBookOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
};

const AcademicSubjects = ({ getAcademicSubjects, data, isFromEditAcademicInterest }) => {
  const location = useLocation();
  const mentorId = location?.state?.mentorId;
  const { savedAnswer, studentProfileIfo } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { ACADEMIC_BACKGROUND } = mentorId ? studentProfileIfo : savedAnswer;
  
  const defaultvals = !isEmpty(ACADEMIC_BACKGROUND) && ACADEMIC_BACKGROUND?.find(obj => obj?.sub_category_name === 'FAVOURITE_SUBJECTS_IN_SCHOOL')?.options?.map(option => option?.option_id) || [];

  const [subjectOption, setSubjectOption] = useState(defaultvals);
  const handleCheckboxChange = (optionId) => {
    if (subjectOption.includes(optionId)) {
      setSubjectOption((prevSubjectOption) => prevSubjectOption.filter((id) => id !== optionId));
    } else if (subjectOption.length < 2) {
      setSubjectOption((prevSubjectOption) => [...prevSubjectOption, optionId]);
    }
  };

  useMemo(() => {
    getAcademicSubjects(subjectOption);
  }, [subjectOption]);

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Box variant="form">
          {!isFromEditAcademicInterest && <Typography variant="h2">{en.ACADEMICSUBJECTS_TITLE}</Typography>}
          <OptionsWrapper>
            <Typography variant="h3" sx={{ mb: 0 }}>
              {data?.question_text}<span style={{color: "#DC3545" }}> *</span>
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "12px", color: "#666666" }}>
              {/* Add any additional information */}
            </Typography>
            <FormGroup sx={{ mt: 2 }}>
              {data?.options?.map((option) => (
                <FormControlLabel
                  key={option?.option_id}
                  control={
                    <Checkbox
                      checked={subjectOption.includes(option?.option_id)}
                      onChange={() => handleCheckboxChange(option?.option_id)}
                    />
                  }
                  label={
                    <React.Fragment>
                      {iconMap[option?.option_text]}
                      {option?.option_text}
                    </React.Fragment>
                  }
                />
              ))}
            </FormGroup>
          </OptionsWrapper>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AcademicSubjects;
